"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var path_1 = __importDefault(require("path"));

var DEFAULT_BASE = 'http://host';
var defaultOptions = {
  trailingSlash: true
};
/**
 * Normalizer for link hrefs.
 * - Treats links with explicit hosts as external and doesn't touch them. For internal
 * - Appends or strips trailing slashes per option (but never appends for file links).
 * - Prepends slash for links which are not explicitly relative (begin with # or .).
 */

var DefaultNormalHref =
/** @class */
function () {
  function DefaultNormalHref(urlString, options) {
    if (options === void 0) {
      options = {};
    }

    this.urlString = (urlString === null || urlString === void 0 ? void 0 : urlString.trim()) || '#';
    this.options = __assign(__assign({}, defaultOptions), options);
    this.url = new URL(this.urlString, DEFAULT_BASE);
  }

  Object.defineProperty(DefaultNormalHref.prototype, "isExternal", {
    get: function get() {
      var base = new URL('', DEFAULT_BASE);
      return this.url.host !== base.host;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DefaultNormalHref.prototype, "hasNoPath", {
    get: function get() {
      return Boolean(this.urlString.match(/^[#?]/));
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DefaultNormalHref.prototype, "isHashOnly", {
    get: function get() {
      return Boolean(this.urlString.match(/^[#]/));
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DefaultNormalHref.prototype, "isRelative", {
    get: function get() {
      return !this.isExternal && (Boolean(this.relativePrefix) || this.hasNoPath);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DefaultNormalHref.prototype, "relativePrefix", {
    get: function get() {
      if (this.isHashOnly) return '';
      if (this.hasNoPath) return '.';
      var rel = this.urlString.match(/^\.[./]+/g);
      if (!rel) return '';
      return rel[0].replace(/\/+$/g, '');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DefaultNormalHref.prototype, "pathname", {
    get: function get() {
      if (this.isExternal) return this.url.pathname;
      if (this.isHashOnly) return '';
      var basePathname = "" + this.relativePrefix + this.url.pathname;
      var stripped = basePathname.replace(/\/+$/g, ''); // Append trailing slash if requested and not a file link, and always for homepage.

      return stripped.length === 0 || this.options.trailingSlash && !path_1.default.extname(stripped) ? stripped + "/" : stripped;
    },
    enumerable: false,
    configurable: true
  });

  DefaultNormalHref.prototype.toString = function () {
    if (this.isExternal) return this.urlString;
    return "" + this.pathname + this.url.search + this.url.hash || '#';
  };

  DefaultNormalHref.prototype.canCompare = function (that) {
    // We don't handle external urls at all.
    if (this.isExternal || that.isExternal) return false; // Never match relative URLs bc we don't know the page they come from.

    if (this.isRelative || that.isRelative) return false;
    return true;
  };

  DefaultNormalHref.prototype.isSamePage = function (that) {
    var that$ = typeof that === 'string' ? new DefaultNormalHref(that) : that;
    if (!this.canCompare(that$)) return false;
    return this.pathname === that$.pathname;
  };

  Object.defineProperty(DefaultNormalHref.prototype, "parentPage", {
    get: function get() {
      if (this.pathname === '/') return undefined;
      var parent = new DefaultNormalHref(this.toString());
      parent.url.pathname = path_1.default.dirname(this.pathname);
      return parent;
    },
    enumerable: false,
    configurable: true
  });

  DefaultNormalHref.prototype.isChildPageOf = function (that) {
    var that$ = typeof that === 'string' ? new DefaultNormalHref(that) : that;
    if (!this.canCompare(that$)) return false;

    for (var p = this; p; p = p.parentPage) {
      if (p.isSamePage(that$)) return true;
    }

    return false;
  };

  return DefaultNormalHref;
}();

exports.default = DefaultNormalHref;